module.exports = __webpack_public_path__ + "teamwork-logo.png";